<template>
  <div class="reload">
    <div class="pic">
      <img :src="errorPic" alt="" />
    </div>
    <div class="tips">加载失败，请刷新重试</div>
    <div class="btn" @click="handleRetry">
      <ReloadOutlined />
      <span class="refresh">刷新</span>
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue'
import { ReloadOutlined } from '@ant-design/icons-vue'
import errorPic from '@/assets/img/network-err.png'

const emit = defineEmits(['retry'])

const handleRetry = () => {
  emit('retry')
}
</script>

<style scoped lang="scss">
.reload {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  .pic {
    margin-bottom: 20px;
  }
  .tips {
    font-size: 12px;
    color: #999999;
    text-align: center;
    margin-bottom: 34px;
  }
  .btn {
    display: flex;
    width: 70px;
    height: 28px;
    background: #1890ff;
    border-radius: 2px;
    color: #ffffff;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    cursor: pointer;
    margin-left: 15px;

    .refresh {
      margin-left: 5px;
    }
  }
}
</style>
